/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

window.addEventListener("load", function () {
    if(currentCountryIsoCode === 'CA') {
        customMoneyFormat()
    }
    
    initProductDescriptionTruncation()
    
    function customMoneyFormat() {
        console.log('customMoneyFormat')
        
        // Find all the elements with the money class and update the format
        // Example: <span class="money">$25.97</span> => <span class="money">CA $25.97</span>
        const moneyElements = document.querySelectorAll('.money')
        moneyElements.forEach((element) => {
            const moneyValue = element.innerText

            if(!moneyValue.includes('$') || moneyValue.includes('CA')) return
            
            element.innerText = `CA ${moneyValue}`
        })
    }
    
    function initProductDescriptionTruncation() {
        const productDescriptions = document.querySelectorAll('.product-description-text')
        
        productDescriptions.forEach((descriptionContainer) => {
            const content = descriptionContainer.querySelector('.product-description-content')
            const toggleButton = descriptionContainer.querySelector('.product-description-toggle')
            
            if (!content || !toggleButton) return
            
            const lineHeight = parseFloat(window.getComputedStyle(content).lineHeight)
            const maxHeight = lineHeight * 3
            
            if (content.scrollHeight > maxHeight) {
                content.classList.add('truncated')
                toggleButton.style.display = 'block'
                
                toggleButton.addEventListener('click', function() {
                    const isExpanded = content.classList.contains('truncated')
                    
                    if (isExpanded) {
                        content.classList.remove('truncated')
                        content.style.maxHeight = content.scrollHeight + 'px'
                        toggleButton.classList.add('expanded')
                    } else {
                        content.classList.add('truncated')
                        content.style.maxHeight = maxHeight + 'px'
                        toggleButton.classList.remove('expanded')
                    }
                })
            }
        })
    }
})